import gql from "graphql-tag";

const SUB_FORM_SUBMISSION_DETAIL = gql`
    subscription formSubmissionDetail($form_submission_detail_id:Int!){
        formSubmissionDetail(form_submission_detail_id: $form_submission_detail_id)
    }
`;

export default SUB_FORM_SUBMISSION_DETAIL;
